import React from 'react';

import i18n from 'I18n';

import { NO_TRANSACTION_HISTORY } from 'utils/Config';

import './ActivityLogTransactionCard.scss';

const ActivityLogTransactionCard = ({ transactionInfo }) => (
  <div className="activity-log-transaction">
    <div className="transaction_invoice">
      <div className="body-2">
        {i18n.t('records:transaction_invoice')}: {transactionInfo.invoiceID}
      </div>
      {NO_TRANSACTION_HISTORY ? null : (
        <img
          className="p2_color_image rotate_90"
          src="/action/chevron.png"
          srcSet="/action/chevron@2x.png 2x, /action/chevron@3x.png 3x"
        />
      )}
    </div>
    <div className="content caption">
      <div>
        {i18n.t('records:transaction_date')}: {transactionInfo.date}
      </div>
      <div>
        {i18n.t('records:transaction_total')}: {transactionInfo.totalValue}
      </div>
      <div>
        {i18n.t('records:transaction_total_eligible')}: {transactionInfo.paidAmount}
      </div>
    </div>
  </div>
);

export default ActivityLogTransactionCard;
